/**
 * @fileoverview 共通フッター component
 */
'use strict';
// React Import
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
// Library Import
import _ from 'lodash';
import { os } from '../../lib/mobiscroll/util/platform';
// Config Import
import AppConfig from '../../AppConfig';
// Core Import
import Content from '../core/Content';
// Util Import
import * as ConstUtil from '../../util/ConstUtil';

/**
 * 共通フッター
 *
 * @class Footer
 * @extends {Content}
 */
class Footer extends Content {
  constructor(props) {
    super(props);
    this.state;
    _.bindAll(this, 'getRefFooter');
  }

  /**
   * Component 更新前処理
   *
   * @memberof Footer
   */
  componentDidUpdate() {
    this.props.setHeight(this.refFooter.offsetHeight);
  }

  /**
   * フッターの参照取得
   *
   * @param {Object} node ノード情報
   * @returns
   * @memberof Footer
   */
  getRefFooter(node) {
    if (_.isEmpty(node)) {
      return;
    }
    this.refFooter = node;
  }

  /**
   * Footer描画
   *
   * @returns
   * @memberof Footer
   */
  renderFooter() {
    // Android と iOSの場合
    if (os === 'android' || os === 'ios') {
      return this.renderMobileFooter();
    }
    return (
      <footer ref={this.getRefFooter}>
        <div className="copy-right">{ConstUtil.Message.COMMON.ID201}</div>
        <div className="app-version">
          {AppConfig.versionInformation.version +
            '.' +
            AppConfig.versionInformation.revision}
        </div>
      </footer>
    );
  }

  /**
   * モバイルFooter描画
   *
   * @returns
   * @memberof Footer
   */
  renderMobileFooter() {
    // 未ログインの場合
    if (
      _.isEmpty(localStorage.getItem(ConstUtil.Common.STORAGE_KEY.AUTHORITY_ID))
    ) {
      return <footer className="hide" ref={this.getRefFooter} />;
    }
    return (
      <footer ref={this.getRefFooter}>
        <div className="copy-right">{ConstUtil.Message.COMMON.ID201}</div>
      </footer>
    );
  }

  /**
   * 描画
   *
   * @returns
   * @memberof Footer
   */
  render() {
    return this.renderFooter();
  }
}

Footer.propTypes = {
  setHeight: PropTypes.func.isRequired
};
export default Footer;



// WEBPACK FOOTER //
// ./src/js/component/core/Footer.jsx